module.exports = __webpack_public_path__ + "Simple-Line-Icons.78f07e2c2a535c26ef21.woff";


//////////////////
// WEBPACK FOOTER
// C:/Users/oggy.yuristantyo/source/Workspaces/UI_SBN_Ritel_Web/src/fonts/Simple-Line-Icons.woff?v=2.4.0
// module id = ../../../../../src/fonts/Simple-Line-Icons.woff?v=2.4.0
// module chunks = 2